import React from'react';var NavigationContext=React.createContext(undefined);export default NavigationContext;
//# sourceMappingURL=NavigationContext.js.map